// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"305":"4be4496e","508":"3eddc430","672":"1375ffa7","985":"1d10a22a"}[chunkId] + ".js";
};